import YouTube from "react-youtube";
import "./../styles/yt-marketing-player.scss";
import { useEffect, useRef } from "react";

const playyerVars = {
    autoplay: 1,
    rel: 0,
    loop: 1,
    mute: 1,
    controls: 0,
    color: "white",
    modestbranding: 0,
    playsinline: 1,
    enablejsapi: 1,
    showinfo: 0,
    cc_load_policy: 3,
    iv_load_policy: 3
};

const YouTubeMarketingPlayer = ({
    youtubeId,
    pausable = false,
    options = {},
    playOnHover = false,
    playing = false,
    setPlaying = () => { },
}) => {
    const playerRef = useRef(null);
    const PLAYER_OPTIONS = {
        width: "100%",
        height: "100%",
        playerVars: { ...playyerVars, ...options, playlist: youtubeId }
    };

    const onReady = (event) => {
        playerRef.current = event.target;

        const shouldAutoplay = PLAYER_OPTIONS.playerVars.autoplay === 1;

        if (shouldAutoplay) {
            event.target.playVideo();
            setPlaying(true);
        } else {
            event.target.pauseVideo();
        }
    };

    const onPlay = () => {
        if (!playing) {
            setPlaying(true, youtubeId);
        }
    };

    const onPause = () => {
        if (playing) {
            setPlaying(false, youtubeId);
        }
    };

    const handleMouseEnter = (play) => {
        if(!playOnHover || !playerRef?.current) return;

        if (play && !playing) {
            playerRef.current.playVideo();
            setPlaying(true, youtubeId);
        }
    };

    useEffect(() => {
        if (!playerRef.current) return;

        if (playing) {
            playerRef.current.playVideo();
        } else {
            playerRef.current.pauseVideo();
        }
    }, [playing]);

    return (
        <div className={`yt-marketing-player ${pausable ? "pausable" : ""} ${PLAYER_OPTIONS.playerVars.controls === 1 ? "controls" : ""}`}
            onMouseEnter={() => handleMouseEnter(true)}
            onFocus={() => handleMouseEnter(true)}
            onMouseLeave={() => handleMouseEnter(false)}
            onBlur={() => handleMouseEnter(false)}>
            <YouTube
                videoId={PLAYER_OPTIONS.playerVars.playlist}
                opts={PLAYER_OPTIONS}
                onReady={onReady}
                onPlay={onPlay}
                onPause={onPause}
            />
        </div>
    );
};

export default YouTubeMarketingPlayer;
